/**
 * React-хост «Аэропорт: Снежный фронт».
 *
 * TypeScript Session + CanvasRenderer + DomShell на весь viewport.
 */

import { useEffect, useRef } from "react";
import { bootTypeScriptGame } from "@/game/runtime/bootGame";

/**
 * Хост на весь viewport. Разметка использует `#app { position: fixed }`.
 */
export function AirportHost() {
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const handle = bootTypeScriptGame(host);
    return () => handle.dispose();
  }, []);

  return <div ref={hostRef} className="airport-host" aria-live="polite" />;
}
